import { defaultListRequestParams } from 'views/components/TableFilters/data'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import { ListRequestParams } from 'modules/domain/types'
import { SamplesFilters } from './SamplesFilters'
import * as Layout from 'views/layouts/NewLayout'
import * as Header from 'views/ui/Header/Header'
import { useTranslation } from 'react-i18next'
import { endpoints } from 'modules/endpoints'
import { useFilters } from 'hooks/useFilter'
import { useColumns } from './useColumns'
import { FC, useState } from 'react'
import { defaultTheme, useHelmet } from '@agro-club/agroclub-shared'
import { SampleForList, SampleReactionStatus } from '../types'

const reactionStatusesColors = {
  [SampleReactionStatus.expired]: defaultTheme.color.accentDestruct8a,
  [SampleReactionStatus.norm]: 'inherit',
  [SampleReactionStatus.paused]: defaultTheme.color.accentNotify8a,
  [SampleReactionStatus.reacted]: 'inherit',
}
export const SamplesList: FC = () => {
  const { t } = useTranslation('samples')
  useHelmet({ title: t('samples') })
  const [listRequestParams, setListRequestParams] = useState<ListRequestParams>(defaultListRequestParams)

  const { isFiltersLoaded, updateFilterState } = useFilters({
    listRequestParams,
    setListRequestParams,
  })

  const columns = useColumns(listRequestParams.sort)

  return (
    <APageWrapper page="Samples" place="SamplesList">
      <Layout.WrapperContent>
        <Layout.Header>
          <Layout.TopHeader>
            <Header.Breadcrumbs routes={[{ breadcrumbName: t('list.heading') }]} />
          </Layout.TopHeader>
          <Layout.PageName>{t('list.heading')}</Layout.PageName>
          <SamplesFilters
            setListRequestParams={setListRequestParams}
            listRequestParams={listRequestParams}
            updateFilterState={updateFilterState}
          />
        </Layout.Header>

        <ATableFullPage
          listParamsUpdated={setListRequestParams}
          listRequestParams={listRequestParams}
          dataEndpoint={endpoints.samples()}
          isFiltersLoaded={isFiltersLoaded}
          columns={columns}
          rowHoverGray
          onRow={(record: SampleForList) => ({
            style: {
              backgroundColor: reactionStatusesColors[record.reaction_status],
            },
          })}
        />
      </Layout.WrapperContent>
    </APageWrapper>
  )
}
